

import { X, Loader2 } from 'lucide-react';

import { SOURCES } from './contactListTypes';
import { useContactsController } from './useContactsController';
export function ContactEditImportDialogs({ ctx }: { ctx: ReturnType<typeof useContactsController> }) {
const { accounts, products, showEditModal, setShowEditModal, setEditId, editForm, setEditForm, editSaving, deleteId, setDeleteId, deleteName, deleting, showImportModal, setShowImportModal, importPreview, importAllRows, importing, importResult, handleEdit, handleDelete, handleCsvFileChange, handleImport } = ctx;
return (<>{showEditModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={() => { setShowEditModal(false); setEditId(null); }}>
          <div className="mx-4 w-full max-w-lg rounded-xl bg-white shadow-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4 rounded-t-xl">
              <h2 className="text-lg font-semibold text-gray-900">Edit Contact</h2>
              <button onClick={() => { setShowEditModal(false); setEditId(null); }} className="text-gray-400 hover:text-gray-600">
                <X size={20} />
              </button>
            </div>
            <div className="space-y-4 px-6 py-4">
              <label className="block text-sm">Contact nature<select aria-label="Contact nature" value={editForm.nature} onChange={e => setEditForm({ ...editForm, nature: e.target.value })} className="block w-full rounded border p-2"><option value="">Not recorded</option>{['plumber', 'dealer', 'architect', 'affiliate', 'other', 'team'].map(nature => <option key={nature} value={nature}>{nature}</option>)}</select></label>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">First Name *</label>
                  <input type="text" value={editForm.firstName} onChange={(e) => setEditForm({ ...editForm, firstName: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Last Name *</label>
                  <input type="text" value={editForm.lastName} onChange={(e) => setEditForm({ ...editForm, lastName: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Email</label>
                <input type="email" value={editForm.email} onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Phone</label>
                  <input type="tel" value={editForm.phone} onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Title</label>
                  <input type="text" value={editForm.title} onChange={(e) => setEditForm({ ...editForm, title: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Product Interest</label>
                <div className="relative">
                  <div
                    className="min-h-[38px] w-full cursor-pointer rounded-lg border border-gray-300 px-3 py-1.5 text-sm focus-within:border-[var(--ink-0)] focus-within:ring-1 focus-within:ring-[var(--ink-0)]"
                    onClick={() => {
                      const el = document.getElementById('pi-dropdown-edit');
                      if (el) el.classList.toggle('hidden');
                    }}
                  >
                    {editForm.productInterest ? (
                      <div className="flex flex-wrap gap-1">
                        {editForm.productInterest.split(', ').map((p, i) => (
                          <span key={i} className="inline-flex items-center gap-1 rounded-full bg-purple-50 px-2 py-0.5 text-xs font-medium text-purple-700">
                            {p}
                            <button type="button" onClick={(e) => {
                              e.stopPropagation();
                              const updated = editForm.productInterest.split(', ').filter((_, idx) => idx !== i).join(', ');
                              setEditForm({ ...editForm, productInterest: updated });
                            }} className="text-purple-400 hover:text-purple-600"><X size={10} /></button>
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-gray-400">Select products...</span>
                    )}
                  </div>
                  <div id="pi-dropdown-edit" className="hidden absolute z-20 mt-1 w-full max-h-48 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
                    {products.map(p => {
                      const selected = editForm.productInterest.split(', ').filter(Boolean).includes(p.name);
                      return (
                        <label key={p.id} className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-50 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selected}
                            onChange={() => {
                              const current = editForm.productInterest.split(', ').filter(Boolean);
                              const updated = selected ? current.filter(x => x !== p.name) : [...current, p.name];
                              setEditForm({ ...editForm, productInterest: updated.join(', ') });
                            }}
                            className="rounded border-gray-300 text-[var(--ink-0)] focus:ring-[var(--ink-0)]"
                          />
                          {p.name}
                        </label>
                      );
                    })}
                    {products.length === 0 && <div className="px-3 py-2 text-xs text-gray-400">No products found</div>}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Account</label>
                  <select value={editForm.accountId} onChange={(e) => setEditForm({ ...editForm, accountId: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none">
                    <option value="">None</option>
                    {accounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                  </select>
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Source</label>
                  <select value={editForm.source} onChange={(e) => setEditForm({ ...editForm, source: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none">
                    <option value="">Select Source</option>
                    {SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Tags</label>
                <input type="text" placeholder="Comma-separated tags" value={editForm.tags} onChange={(e) => setEditForm({ ...editForm, tags: e.target.value })}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
              </div>
              <div className="border-t border-gray-100 pt-3">
                <p className="mb-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Location</p>
                <div className="grid grid-cols-2 gap-3 mb-3">
                  <input type="text" placeholder="City" value={editForm.city} onChange={(e) => setEditForm({ ...editForm, city: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                  <input type="text" placeholder="State" value={editForm.state} onChange={(e) => setEditForm({ ...editForm, state: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Notes</label>
                <textarea rows={3} placeholder="Free-form notes about this contact..." value={editForm.notes} onChange={(e) => setEditForm({ ...editForm, notes: e.target.value })}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
              </div>
              <div className="border-t border-gray-100 pt-3">
                <p className="mb-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Address</p>
                <div className="space-y-3">
                  <input type="text" placeholder="Street" value={editForm.street} onChange={(e) => setEditForm({ ...editForm, street: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                  <div className="grid grid-cols-3 gap-3">
                    <input type="text" placeholder="City" value={editForm.city} onChange={(e) => setEditForm({ ...editForm, city: e.target.value })}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                    <input type="text" placeholder="State" value={editForm.state} onChange={(e) => setEditForm({ ...editForm, state: e.target.value })}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                    <input type="text" placeholder="Pincode" value={editForm.pincode} onChange={(e) => setEditForm({ ...editForm, pincode: e.target.value })}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 border-t border-gray-200 px-6 py-4">
              <button onClick={() => { setShowEditModal(false); setEditId(null); }}
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Cancel</button>
              <button onClick={handleEdit} disabled={editSaving || !editForm.firstName || !editForm.lastName}
                className="flex items-center gap-2 rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--ink-1)] disabled:opacity-50">
                {editSaving && <Loader2 size={14} className="animate-spin" />}
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={() => setDeleteId(null)}>
          <div className="mx-4 w-full max-w-sm rounded-xl bg-white shadow-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-5 sticky top-0 z-10 bg-white rounded-t-xl">
              <h2 className="mb-2 text-lg font-semibold text-gray-900">Delete Contact</h2>
              <p className="text-sm text-gray-600">
                Are you sure you want to delete <span className="font-medium">{deleteName}</span>? This action cannot be undone.
              </p>
            </div>
            <div className="flex items-center justify-end gap-3 border-t border-gray-200 px-6 py-4">
              <button onClick={() => setDeleteId(null)}
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Cancel</button>
              <button onClick={handleDelete} disabled={deleting}
                className="flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50">
                {deleting && <Loader2 size={14} className="animate-spin" />}
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Import CSV Modal */}
      {showImportModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={() => setShowImportModal(false)}>
          <div className="mx-4 w-full max-w-2xl rounded-xl bg-white shadow-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4 sticky top-0 z-10 bg-white rounded-t-xl">
              <h2 className="text-lg font-semibold text-gray-900">Import Contacts from CSV</h2>
              <button onClick={() => setShowImportModal(false)} className="text-gray-400 hover:text-gray-600">
                <X size={20} />
              </button>
            </div>
            <div className="space-y-4 px-6 py-4">
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Upload CSV File</label>
                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleCsvFileChange(e.target.files?.[0] || null)}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm file:mr-3 file:rounded-md file:border-0 file:bg-[var(--saffron-50)] file:px-3 file:py-1 file:text-sm file:font-medium file:text-[var(--ink-0)]"
                />
                <p className="mt-1 text-xs text-gray-500">
                  Expected columns: firstName, lastName, email, phone, title, source
                </p>
              </div>

              {importPreview.length > 0 && (
                <div>
                  <p className="mb-2 text-sm font-medium text-gray-700">
                    Preview ({importAllRows.length} rows total, showing first {importPreview.length})
                  </p>
                  <div className="overflow-x-auto rounded border border-gray-200">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="border-b bg-gray-50">
                          {Object.keys(importPreview[0]).map(h => (
                            <th key={h} className="px-2 py-1.5 text-left font-medium text-gray-600">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {importPreview.map((row, i) => (
                          <tr key={i} className="border-b border-gray-100">
                            {Object.values(row).map((v, j) => (
                              <td key={j} className="px-2 py-1.5 text-gray-700">{v}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {importResult && (
                <div className={`rounded-lg px-4 py-3 text-sm ${importResult.success > 0 ? 'border border-green-200 bg-green-50 text-green-700' : 'border border-red-200 bg-red-50 text-red-700'}`}>
                  Imported {importResult.success} contacts successfully.
                  {importResult.errors > 0 && ` ${importResult.errors} rows skipped (missing firstName/lastName).`}
                </div>
              )}
            </div>
            <div className="flex items-center justify-end gap-3 border-t border-gray-200 px-6 py-4">
              <button
                onClick={() => setShowImportModal(false)}
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleImport}
                disabled={importing || importAllRows.length === 0}
                className="flex items-center gap-2 rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--ink-1)] disabled:opacity-50"
              >
                {importing && <Loader2 size={14} className="animate-spin" />}
                Import {importAllRows.length > 0 ? `(${importAllRows.length} rows)` : ''}
              </button>
            </div>
          </div>
        </div>
      )}
    </>);
}
